import Register from "../../component/login & register/Register";



const REGISTER=()=>{
  return(
    <div className="REGISTER">
      {window.innerWidth > 1000 && <Register mode={1} />}
      {window.innerWidth < 1000 && <Register mode={2} />}
    </div>
  )
}

export default REGISTER;